import { render } from "./EditAutocomplete.vue?vue&type=template&id=a1058f10"
import script from "./EditAutocomplete.vue?vue&type=script&lang=ts"
export * from "./EditAutocomplete.vue?vue&type=script&lang=ts"

import "./EditAutocomplete.vue?vue&type=style&index=0&id=a1058f10&lang=scss"
script.render = render

export default script